module.exports = __webpack_public_path__ + "img/c00_buildingtechtraderoutes_Normal_ua.ab406e61.webp";